module.exports = __webpack_public_path__ + "img/ironshore_logo-white.550e5658.png";